/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.9.10",
    versionName: "0.2.0-nightly.2025.9.10",
    versionChannel: "nightly",
    buildDate: "2025-09-10T00:07:37.410Z",
    commitHash: "e3b52d14b864b20dcfef1ed714c7475a5abba00f",
};
